import { create } from 'zustand';

interface WatchedModalState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useWatchedModalStore = create<WatchedModalState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
